module.exports = __webpack_public_path__ + "img/album14_07.19e021e9.jpg";